
import { createAction, props } from '@ngrx/store';
import { Account, OrgProgram, Organization, OrganizationData, Payer } from '../../models';

export const createOrEditOrganization = createAction('[Organization] Create or Edit', props<{ payload: OrganizationData }>());
export const createOrEditOrganizationSuccess = createAction('[Organization] Create or Edit Success', props<{ method: string, orgName: string }>());
export const createOrEditOrganizationFailure = createAction('[Organization] Create or Edit Failure', props<{ method: string, orgName: string}>());

export const deleteOrganization = createAction('[Organization] Delete Organization', props<{ payload: Organization }>());
export const deleteOrganizationSuccess = createAction('[Organization] Delete Organization Success', props<{ orgName: string }>());
export const deleteOrganizationFailure = createAction('[Organization] Delete Organization Failure', props<{ orgName: string }>());

export const getOrganization = createAction('[Organization] Get Organization', props<{ payload: number }>());

export const loadOrganizations = createAction('[Organization] Load Organizations');
export const loadOrganizationsSuccess = createAction('[Organization] Load Organizations Success', props<{ payload: Organization[] }>());
export const loadOrganizationsFailure = createAction('[Organization] Load Organizations Failure', props<{ payload: any }>());

export const loadPayerAccounts = createAction('[Organization] Load Payer Accounts', props<{ payload: number }>());
export const loadPayerAccountsSuccess = createAction('[Organization] Load Payer Accounts Success', props<{ payload: Payer[] }>());
export const loadPayerAccountsFailure = createAction('[Organization] Load Payer Accounts Failure', props<{ payload: any }>());

export const loadOrderAccounts = createAction('[Organization] Load Order Accounts');
export const loadOrderAccountsSuccess = createAction('[Organization] Load Order Accounts Success', props<{ payload: Account[] }>());
export const loadOrderAccountsFailure = createAction('[Organization] Load Order Accounts Failure', props<{ payload: any }>());

export const loadOrgPayerAccounts = createAction('[Organization] Load Organization Payer Accounts', props<{ payload: number }>());
export const loadOrgPayerAccountsSuccess = createAction('[Organization] Load Organization Payer Accounts Success', props<{ payload: Account[] }>());
export const loadOrgPayerAccountsFailure = createAction('[Organization] Load Organization Payer Accounts Failure', props<{ payload: any }>());

export const loadOrgOrderAccounts = createAction('[Organization] Load Organization Order Accounts', props<{ payload: number }>());
export const loadOrgOrderAccountsSuccess = createAction('[Organization] Load Organization Order Accounts Success', props<{ payload: Account[] }>());
export const loadOrgOrderAccountsFailure = createAction('[Organization] Load Organization Order Accounts Failure', props<{ payload: any }>());

export const loadPrograms = createAction('[Organization] Load Programs', props<{ orgId: number }>());
export const loadProgramsSuccess = createAction('[Organization] Load Programs Success', props<{ programs: OrgProgram[] }>());
export const loadProgramsFailure = createAction('[Organization] Load Programs Failure', props<{ err: string }>());

export const deletePrograms = createAction('[Organization] Delete Programs', props<{ orgId: number }>());
export const deleteProgramsSuccess = createAction('[Organization] Delete Programs Success', props<{ orgId: number }>());
export const deleteProgramsFailure = createAction('[Organization] Delete Programs Failure', props<{ err: any }>());

export const setSortOrder = createAction('[Organization] Set Sort Order', props<{ payload: string }>());
export const setOrderAccountsSortOrder = createAction('[Organization] Set Ordering Accounts Sort Order', props<{ payload: string }>());
export const setProgramsSortOrder = createAction('[Organization] Set Programs Sort Order', props<{ payload: string }>());

export const organizationsFailure = createAction('[Organization] Organization Failure Error', props<{ payload: string }>());




